// extracted by mini-css-extract-plugin
module.exports = {"root":"Mi-W6","wide":"_3tv6q","listContatcs":"t77hT","itemBaltia":"_-8TRv","item":"_1zeFM","textRoot":"_31lxG","text":"_1D72B","marginTop":"_369_s","columnBaltia":"_1Maj6"};